import { memo, useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { AutoSizer, CellMeasurer, CellMeasurerCache, Grid } from "react-virtualized"; //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
import { sendTouchlineRequest } from "../apis/web_socket";
import { INDICES_CONSTANTS, SORT_TYPES } from "../utils/global_variables"; //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
import BzInputText from "./BzInputText";
import { INFINITY_GRID_REF, changeDataInGridFormat, handleScripUnsubScriptionOnUnMount, setInfinityGridRef } from "../utils/global_functions";
import { useDispatch, useSelector } from "react-redux";
import BzDropdown from "./BzDropdown";
import { updateIndicesScrollPosition } from "../redux/actions/indices";
import { useUnload } from "../hooks";



const BzInfiniteScroll = ({ arrScrollableData, favourites, favouriteHandler, GridBody, isExpand, activeTab, onExcahngeFilter, filterDropDownList, sortingFilterNames, onApplyFilter, handleCardClick }) => {

    const dispatch = useDispatch();

    const [searchValue, setSearchValue] = useState("");
    const [exchange, setExchange] = useState('');

    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices  --Start
    const cache = new CellMeasurerCache({
        fixedHeight: false,
        defaultHeight: 162
    });
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices  --End

    const scrollPosition = useSelector(state => state?.indices?.scrollPosition);


    setInfinityGridRef(useRef());


    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -- Issue - when no mathced data found return empty array and toggle alert messsage from ui --Start
    const scrollableData = useMemo(() => {
        const data = arrScrollableData?.map((element) => element?.filter((obj) => obj?.sIndexDesc?.trim()?.toLowerCase()?.includes(searchValue?.trim()?.toLowerCase())))?.filter((subArray) => subArray?.length > 0);
        if (data?.length > 0) {
            return changeDataInGridFormat(data.flat(), isExpand);
        } else {
            return [];
        }
    }, [arrScrollableData, searchValue, isExpand]);
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -- Issue - when no mathced data found return empty array and toggle alert messsage from ui --End
    const [objScripsRequest, setObjScripsRequest] = useState({});
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -- Issue - subscription and unsubscription --Start
    const handleIndicesSubscripandUnSubscription = useCallback((subarr) => {
        let arrVisibleIndices = subarr;
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]

            const arrVisibleRows = arrVisibleIndices.map(item => {
                let id = item;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true });

                }
                return { exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);

            return { ...objpreviosScripsCopy };
        });
    }, []);
    const cellRenderer = useCallback((props) => {
        if (isExpand) {
            if (scrollableData?.length > 1) {
                scrollableData?.slice(props?.rowStartIndex, props?.rowStopIndex+1)?.map((eachScrip) => {
                    const subarrinner = eachScrip?.map((each)=>{
                        return `${each?.nMarketSegmentId + '_' + each?.nToken}`;
                    })
                    handleIndicesSubscripandUnSubscription(subarrinner);
                });
            }
        } else {
            const subarr = scrollableData[0].slice(props?.columnStartIndex, props?.columnStopIndex+1)?.map((eachScrip) => {
                return `${eachScrip?.nMarketSegmentId + '_' + eachScrip?.nToken}`;
            });
            handleIndicesSubscripandUnSubscription(subarr);
        }

    }, [isExpand, scrollableData, handleIndicesSubscripandUnSubscription]);
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -- Issue - subscription and unsubscription --End

    //Ameersha N - 25-10-2023 - Scroll saving and when we want we need to apply same scroll postion- Start
    const handleOnScroll = useCallback(({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }) => {
        dispatch(updateIndicesScrollPosition(scrollLeft));
    }, [dispatch]);

    const handleLeftOverScripsUnSUbscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'indices');
    }, [objScripsRequest]);
    useUnload(() => {
        handleLeftOverScripsUnSUbscription();
    });

    useEffect(() => {
        if (isExpand === undefined || !isExpand) {
            INFINITY_GRID_REF?.current?.scrollToPosition({
                scrollLeft: Number(scrollPosition)
            });
        } else { }

    }, [isExpand, scrollPosition]);
    //Ameersha N - 25-10-2023 - Scroll saving and when we want we need to apply same scroll postion- End
    return (
        <Container fluid className='p-0'>
            <Row className='g-0'>
                <Col>
                    <>
                        {isExpand && sortingFilterNames?.length ?
                            <Container fluid className='p-0'>
                                <Row className='g-0 mt-4 mx-3 justify-content-between align-items-center'> {/* Hari P: 24-11-2023: BT-104813 UI Issue solved - margin class name change */}
                                    <Col md={5}>
                                        <div className='d-flex'>
                                            {filterDropDownList?.length &&
                                                <Col md='auto' className='d-flex justify-content-start align-items-center px-1'> {/* Hari P: 24-11-2023: BT-104813 UI Issue solved - col class name chnage */}
                                                    <div className='screen-dropdown'>
                                                        <BzDropdown>
                                                            <Dropdown.Toggle className='btn-primary'>{exchange ? exchange : filterDropDownList[0]}</Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {filterDropDownList?.map(exchange =>
                                                                    <Dropdown.Item onClick={() => {
                                                                        onExcahngeFilter(exchange);
                                                                        setExchange(exchange);
                                                                    }
                                                                    } key={exchange}>{exchange}</Dropdown.Item>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </BzDropdown>
                                                    </div>
                                                </Col>
                                            }
                                            {sortingFilterNames?.map((filter, index) =>
                                                <Col key={index} className='d-flex justify-content-between align-items-center form-control form-control-sm mx-1'>
                                                    <div className='font-medium font-size1 color-text'>{filter?.name}</div>
                                                    <div className='d-flex flex-column ms-2'>
                                                        <span className='icon-10 icon-arrowup icon-dark ms-1' onClick={() => onApplyFilter(filter?.value, SORT_TYPES.ASC, scrollableData)} />
                                                        <span className='icon-10 icon-arrowdown icon-dark ms-1' onClick={() => onApplyFilter(filter?.value, SORT_TYPES.DESC, scrollableData)} />
                                                    </div>
                                                </Col>)
                                            }
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className='position-relative'>
                                            <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                            <BzInputText type="search" size="sm" id='watchlist_header_search' onChange={(e) => setSearchValue(e?.target?.value)} className='p-l-30  font-regular scripname-searchtext' placeholder={`Search ${activeTab === 'my_favourites' ? 'my favourites...' : 'local indices..'}`} autoComplete='off' />
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                            :
                            null}

                        <div className={isExpand ? 'expand-indices-card-wrap' : 'indices-card-wrap'}>
                            {scrollableData?.length > 0 ?
                                <AutoSizer>
                                    {
                                        ({ width, height }) => {
                                            return (
                                                <Grid
                                                    className={isExpand ? 'd-flex justify-content-start' : ''}
                                                    ref={INFINITY_GRID_REF}
                                                    onScroll={handleOnScroll}
                                                    cellRenderer={({ columnIndex, rowIndex, style, parent }) => {
                                                        return (
                                                            <CellMeasurer
                                                                key={scrollableData[rowIndex][columnIndex]?.nToken || scrollableData[rowIndex][columnIndex]?.IndexID}
                                                                cache={cache}
                                                                parent={parent}
                                                                columnIndex={columnIndex}
                                                                rowIndex={rowIndex}
                                                            >
                                                                <div style={style}>
                                                                    <GridBody
                                                                        eachItem={scrollableData[rowIndex][columnIndex]}
                                                                        favourites={favourites}
                                                                        favouriteHandler={favouriteHandler}
                                                                        isExpand={isExpand} rowIndex={rowIndex}
                                                                        columnIndex={columnIndex}
                                                                        scrollableData={scrollableData}
                                                                        handleCardClick={handleCardClick} />
                                                                </div>
                                                            </CellMeasurer>
                                                        );
                                                    }}
                                                    columnCount={scrollableData?.length ? scrollableData[0]?.length : INDICES_CONSTANTS?.CARDS_PER_SCREEN}
                                                    columnWidth={cache.columnWidth}
                                                    height={height}
                                                    rowCount={scrollableData?.length}
                                                    rowHeight={cache.rowHeight}
                                                    width={width}
                                                    onSectionRendered={cellRenderer}
                                                />

                                            );
                                        }
                                    }
                                </AutoSizer>
                                :
                                <div className='zero-state-alerts zero-state-alerts-md'>
                                    <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                    <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                    <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                </div>
                            }

                        </div>
                    </>
                </Col>
            </Row>
        </Container >
    );
};

export default memo(BzInfiniteScroll);